import React from 'react';

import {
	ArrowFocusTrapContext,
	ArrowFocusTrapContextProps,
} from './contexts/ArrowFocusTrapContext';

type Props<C extends React.ElementType> = JSX.IntrinsicAttributes &
	JSX.LibraryManagedAttributes<C, React.ComponentProps<C>> & {
		ArrowFocusTrapContextProps: ArrowFocusTrapContextProps;
	};

/**
 * wrap component in arrow focus trap provider
 * @example
	const WrappedComponenet = withArrowFocusTrap(Componenet, {...});
 */
export const withArrowFocusTrap = function <C extends React.ElementType>(
	Component: C,
	defaults?: Partial<ArrowFocusTrapContextProps>,
) {
	return React.forwardRef<HTMLDivElement, Props<C>>(
		({ArrowFocusTrapContextProps, ...props}, ref) => {
			return (
				<ArrowFocusTrapContext {...defaults} {...ArrowFocusTrapContextProps}>
					<Component
						{...(props as JSX.IntrinsicAttributes &
							JSX.LibraryManagedAttributes<C, React.ComponentProps<C>>)}
						ref={ref}
					/>
				</ArrowFocusTrapContext>
			);
		},
	);
};

export default withArrowFocusTrap;
